import { ErrorType, IErrorNormalizer, VmafError } from './types';

class WixWizErrorNormalizer implements IErrorNormalizer {
  normalizeToVmafError(e: any): VmafError {
    return new VmafError(
      e.message,
      this.checkAuthError(e) || this.check404Error(e) || ErrorType.UNKNOWN,
      e,
    );
  }

  private checkAuthError(e: any): ErrorType | null {
    if (e.response && e.response.status === 401) {
      return ErrorType.UNAUTHORIZED;
    }

    return null;
  }

  private check404Error(e: any): ErrorType | null {
    if (e.response && e.response.status === 404) {
      return ErrorType.NOT_FOUND;
    }

    return null;
  }
}

export default WixWizErrorNormalizer;
